import React from 'react';

import {
    Modal,
    Select,
    message,
} from 'antd';

const { DELIVERY_MODES_PRETTY } = require('./config');

const { Option } = Select;


class AssignToModal extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            selectedDeliveryMode: false
        }
    }

    render() {

        return (

            <Modal
                title="Assign to Delivery Mode"
                onOk={this.handleOk}
                onCancel={this.props.onCancel}
                // footer={null}
                centered
                visible={this.props.visible}
            >
                <div>
                    <div style={{marginBottom: 8}}>{`Selected ${this.props.selectedLocations.length} locations`}</div>
                    <Select style={{ width: 250 }} onChange={(e) => this.setState({ selectedDeliveryMode: e }) }>
                        {Object.keys(DELIVERY_MODES_PRETTY)
                        .filter(_key => !['janio','lalamove'].includes(_key))
                        .map(_key => {
                            return (
                                <Option value={DELIVERY_MODES_PRETTY[_key]}>{DELIVERY_MODES_PRETTY[_key]}</Option>
                            )
                        })}
                    </Select>
                </div>

            </Modal>
        )
    }

    handleOk = () => {
        if (!this.state.selectedDeliveryMode) { 
            message.error('Please select a delivery mode!', 100)
            return 
        }
        this.props.changeDeliveryMode(this.state.selectedDeliveryMode)
        this.props.onCancel()
    }



}

export default AssignToModal


// WEBPACK FOOTER //
// ./src/components/delivery-page/assign-to-modal.js